import { render, staticRenderFns } from "./IndexTask.vue?vue&type=template&id=b8cc10d0"
import script from "./IndexTask.vue?vue&type=script&lang=js"
export * from "./IndexTask.vue?vue&type=script&lang=js"
import style0 from "./IndexTask.vue?vue&type=style&index=0&id=b8cc10d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports